:host {
  /**
   * @prop --border-radius: Border radius of the menu button
   *
   * @prop --background: Background of the menu button
   * @prop --background-hover: Background of the menu button on hover
   * @prop --background-hover-opacity: Opacity of the background on hover
   * @prop --background-focused: Background of the menu button when focused with the tab key
   * @prop --background-focused-opacity: Opacity of the menu button background when focused with the tab key
   *
   * @prop --color: Color of the menu button
   * @prop --color-hover: Color of the menu button on hover
   * @prop --color-focused: Color of the menu button when focused with the tab key
   *
   * @prop --padding-top: Top padding of the button
   * @prop --padding-end: Right padding if direction is left-to-right, and left padding if direction is right-to-left of the button
   * @prop --padding-bottom: Bottom padding of the button
   * @prop --padding-start: Left padding if direction is left-to-right, and right padding if direction is right-to-left of the button
   */
  --background: transparent;
  --color-focused: currentColor;
  --border-radius: initial;
  --padding-top: 0;
  --padding-bottom: 0;
  color: var(--color);
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
  font-kerning: none;
}

.button-native {
  border-radius: var(--border-radius);
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-indent: inherit;
  text-overflow: inherit;
  text-transform: inherit;
  text-align: inherit;
  white-space: inherit;
  color: inherit;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  -webkit-padding-start: var(--padding-start);
  padding-inline-start: var(--padding-start);
  -webkit-padding-end: var(--padding-end);
  padding-inline-end: var(--padding-end);
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: flex;
  position: relative;
  flex-flow: row nowrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 0;
  outline: none;
  background: var(--background);
  line-height: 1;
  cursor: pointer;
  overflow: hidden;
  user-select: none;
  z-index: 0;
  appearance: none;
}

.button-inner {
  display: flex;
  position: relative;
  flex-flow: row nowrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

ion-icon {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  pointer-events: none;
}

:host(.menu-button-hidden) {
  display: none;
}

:host(.menu-button-disabled) {
  cursor: default;
  opacity: 0.5;
  pointer-events: none;
}

:host(.ion-focused) .button-native {
  color: var(--color-focused);
}
:host(.ion-focused) .button-native::after {
  background: var(--background-focused);
  opacity: var(--background-focused-opacity);
}

.button-native::after {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  content: "";
  opacity: 0;
}

@media (any-hover: hover) {
  :host(:hover) .button-native {
    color: var(--color-hover);
  }
  :host(:hover) .button-native::after {
    background: var(--background-hover);
    opacity: var(--background-hover-opacity, 0);
  }
}
:host(.ion-color) .button-native {
  color: var(--ion-color-base);
}

:host(.in-toolbar:not(.in-toolbar-color)) {
  color: var(--ion-toolbar-color, var(--color));
}

:host {
  --background-focused: currentColor;
  --background-focused-opacity: .1;
  --border-radius: 4px;
  --color: var(--ion-color-primary, #3880ff);
  --padding-start: 5px;
  --padding-end: 5px;
  height: 32px;
  font-size: 31px;
}

:host(.ion-activated) {
  opacity: 0.4;
}

@media (any-hover: hover) {
  :host(:hover) {
    opacity: 0.6;
  }
}